




// import React, { useEffect, useState } from 'react';
// import './Management.css';
// import { FaTrash, FaEye } from 'react-icons/fa'; // Trash and View icon
// import axios from 'axios';
// import { useLoader } from '../../../../context/LoaderProvider';

// // import './Management3.css'



// const Standardorder = () => {
//   const [activeTab, setActiveTab] = useState('Order Life-Cycle');
//   const [data, setData] = useState([]);
//   const [orders, setOrders] = useState([]);
//   const { showLoader, hideLoader } = useLoader();
//   const [loading, setLoading] = useState(false);
//   const [selectedItems, setSelectedItems] = useState([]);

//   const [vendorId, setVendorId] = useState(null);
//   const [allOrders, setAllOrders] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(""); // format: YYYY-MM-DD
//   const screenWidth = window.innerWidth;
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//   // Add these with your other useState declarations:
//   const [statusOrders, setStatusOrders] = useState([]); // Only current page orders
//   const [currentPage, setCurrentPage] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const [pageSize] = useState(10); // Fixed at 10
//   const [totalElements, setTotalElements] = useState(0);
//   const [isLoadingStatus, setIsLoadingStatus] = useState(false);
//   const [filteredOrders, setFilteredOrders] = useState([]);


//   const containerHeight = window.innerWidth < 768
//     ? '300px'       // Mobile
//     : window.innerWidth < 850
//       ? '300px'     // Below 850px
//       : window.innerWidth < 1400
//         ? '410px'   // Between 850px and 1399px
//         : window.innerWidth < 1600
//           ? '480px' // Between 1400px and 1599px
//           : '640px'; // Above 1600px






//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);



//   useEffect(() => {
//     let filtered = [...statusOrders];

//     if (selectedDate) {
//       const s = new Date(selectedDate);
//       s.setHours(0, 0, 0, 0);

//       const e = new Date(selectedDate);
//       e.setHours(23, 59, 59, 999);

//       filtered = filtered.filter(order => {
//         const date = new Date(order.orderDateAndTime);
//         return date >= s && date <= e;
//       });
//     }

//     setFilteredOrders(filtered);
//   }, [selectedDate, statusOrders]);

//   // Fetch orders from API
//   useEffect(() => {
//     if (!vendorId) return;

//     const fetchOrders = async () => {
//       const token = localStorage.getItem("authToken");
//       if (!token) {
//         console.error("Authorization token missing");
//         return;
//       }

//       try {
//         let pageIndex = 0;
//         let allNormalOrders = [];
//         let morePages = true;

//         // 🔵 Fetch ALL PAGINATED ORDERS page by page
//         while (morePages) {
//           const res = await axios.get(
//             `https://backend.maamaas.com/food/api/orders/vendor/paginated/${vendorId}/${pageIndex}/10`,
//             { headers: { Authorization: `Bearer ${token}` } }
//           );

//           const response = res.data;

//           if (!response || !Array.isArray(response.content)) break;

//           const pageData = response.content;

//           if (pageData.length === 0) break;

//           allNormalOrders = [...allNormalOrders, ...pageData];

//           if (pageData.length < 10) {
//             morePages = false;
//           } else {
//             pageIndex++;
//           }
//         }

//         // 🔵 Fetch DINE-IN completed orders
//         const dineInRes = await axios.get(
//           `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/COMPLETED`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         const dineInRaw = dineInRes.data || [];

//         const dineInOrders = dineInRaw.map((order) => ({
//           orderId: order.cartId,
//           orderDateAndTime: order.cartDateAndTime || new Date().toISOString(),
//           appType: "Food",
//           orderService: order.orderType,
//           userName: order.userName || "Dine-In User",
//           paymentMethod: order.paymentMethod || "N/A",
//           status: "COMPLETED",
//           grandTotal: order.grandTotal || 0,
//         }));

//         // 🔥 Combine both
//         const allData = [...allNormalOrders, ...dineInOrders];

//         //console.log("ALL COMBINED ORDERS:", allData);

//         setAllOrders(allData);
//         setFilteredData(allData); // initial display

//       } catch (error) {
//         console.error("Error fetching orders:", error);
//       }
//     };

//     fetchOrders();
//   }, [vendorId]);


//   // Filter orders whenever selectedDate changes
//   useEffect(() => {
//     if (!selectedDate) {
//       setFilteredData(allOrders); // show all if no date selected
//       return;
//     }

//     const filtered = allOrders.filter((order) => {
//       const orderDate = new Date(order.orderDateAndTime)
//         .toISOString()
//         .split("T")[0]; // format YYYY-MM-DD
//       return orderDate === selectedDate;
//     });

//     setFilteredData(filtered);
//   }, [selectedDate, allOrders]);




//   useEffect(() => {
//     const storedVendorId = localStorage.getItem("vendorId");
//     if (storedVendorId) {
//       setVendorId(storedVendorId);
//     }
//   }, []);
//   useEffect(() => {
//     if (!vendorId) return;

//     fetchOrders(); // Initial fetch

//     const intervalId = setInterval(fetchOrders, 5000); // Poll every 5 seconds
//     return () => clearInterval(intervalId);
//   }, [vendorId]);

//   const [combinedData, setCombinedData] = useState([]);

//   useEffect(() => {
//     if (!vendorId) return;

//     const fetchData = () => {
//       const token = localStorage.getItem("authToken"); // ✅ Retrieve token from storage
//       if (!token) {
//         console.warn("No auth token found. Skipping fetch.");
//         return;
//       }

//       axios
//         .get(
//           `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`, // ✅ Include token in header
//             },
//           }
//         )
//         .then((res) => setData(res.data))
//         .catch((err) =>
//           console.error("Error fetching orders with token:", err.response?.data || err.message)
//         );
//     };

//     fetchData(); // initial fetch

//     const interval = setInterval(fetchData, 100000); // fetch every 1 second

//     return () => clearInterval(interval); // cleanup
//   }, [vendorId]);


//   // Fetch paginated orders - 10 per page
//   // Fetch paginated orders for Status tab ONLY
//   const fetchPaginatedOrders = async (page = 0) => {
//     if (!vendorId) return;

//     setIsLoadingStatus(true);
//     const token = localStorage.getItem("authToken");

//     try {
//       const response = await axios.get(
//         `https://backend.maamaas.com/food/api/orders/vendor/paginated/${vendorId}/${page}/10`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       let orders = [];
//       let pages = 1;

//       // CASE A: API sends paginated structure
//       if (response.data?.content) {
//         orders = response.data.content;
//         pages = response.data.totalPages;
//         //console.log("Paginated API detected");
//       }

//       // CASE B: API sends array only
//       else if (Array.isArray(response.data)) {
//         orders = response.data;
//         pages = Math.ceil(response.data.length / 10); // FIX HERE
//         //console.log("Array API detected → pages:", pages);
//       }

//       // DATE FILTER
//       if (selectedDate) {
//         orders = orders.filter(order => {
//           return order.orderDateAndTime?.split("T")[0] === selectedDate;
//         });
//       }

//       const formatted = orders.map(order => ({
//         orderId: order.orderId,
//         orderDateAndTime: order.orderDateAndTime,
//         orderType: order.orderType?.replace(/[_-]/g, "") ?? "N/A",
//         paymentMethod: order.paymentMethod?.replace(/[_-]/g, "") ?? "N/A",
//         status: order.status,
//         grandTotal: order.grandTotal ?? 0,
//       }));

//       setStatusOrders(formatted);
//       setTotalPages(pages);   // ⬅ SET CORRECT TOTAL PAGES
//       setCurrentPage(page);

//     } catch (err) {
//       console.error(err);
//     } finally {
//       setIsLoadingStatus(false);
//     }
//   };


//   const goNext = () => {
//     fetchPaginatedOrders(currentPage + 1);
//   };

//   const goPrevious = () => {
//     if (currentPage > 0) {
//       fetchPaginatedOrders(currentPage - 1);
//     }
//   };

//   const getVisiblePages = () => {
//     const pages = [];

//     for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//       if (i >= 0) pages.push(i);
//     }

//     return pages;
//   };



//   // Fetch initial data when component loads
//   // Fetch paginated orders when vendorId is available
//   useEffect(() => {
//     if (vendorId && activeTab === 'Status') {
//       fetchPaginatedOrders(0); // Start with page 0
//     }
//   }, [vendorId, activeTab]);

//   // Refetch when date changes
//   useEffect(() => {
//     if (vendorId && activeTab === 'Status') {
//       setCurrentPage(0); // Reset to first page
//       fetchPaginatedOrders(0); // Fetch with new date filter
//     }
//   }, [selectedDate, activeTab]);

//   // Add these functions inside your Standardorder component (after useState declarations)

//   // 1. Fetch orders function
//   const fetchOrders = async () => {
//     if (!vendorId) return;

//     const token = localStorage.getItem("authToken");
//     if (!token) {
//       console.warn("Auth token missing. Skipping order fetch.");
//       return;
//     }

//     try {
//       // 1️⃣ Fetch normal orders
//       const ordersRes = await axios.get(
//         `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       // ✅ CRITICAL FIX: Include BEING_PREPARED
//       const processingOrders = ordersRes.data.filter(order =>
//         ["CONFIRMED", "PROCESSING", "ORDER_IS_READY", "WAITING_FOR_PICKUP"].includes(order.status)
//       );

//       // 2️⃣ Fetch TABLE_DINE_IN orders for relevant statuses
//       const dineInStatuses = ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"];
//       const dineInPromises = dineInStatuses.map(status =>
//         axios.get(
//           `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/${status}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         )
//       );

//       const dineInResponses = await Promise.all(dineInPromises);
//       let dineInOrders = dineInResponses.flatMap(res => res.data || []);

//       // Filter TABLE_DINE_IN orders by cartItems status
//       dineInOrders = dineInOrders.filter(order =>
//         Array.isArray(order.cartItems) &&
//         order.cartItems.some(item =>
//           ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"].includes(item.orderStatus)
//         )
//       );

//       // 3️⃣ Combine and deduplicate
//       const combinedOrders = [...processingOrders, ...dineInOrders];
//       const uniqueOrders = combinedOrders.filter(
//         (order, index, self) =>
//           index === self.findIndex(
//             o => (o.cartId && o.cartId === order.cartId) || (o.orderId && o.orderId === order.orderId)
//           )
//       );

//       //console.log("📦 Orders in Order Life-Cycle:", uniqueOrders.length);
//       setOrders(uniqueOrders);
//     } catch (error) {
//       console.error("❌ Failed to fetch orders:", error.response?.data || error.message);
//     }
//   };

//   // 2. Helper to get selected dine-in items
//   const getSelectedDineInItems = (order) => {
//     if (!order.cartItems || order.orderType !== "TABLE_DINE_IN") return [];

//     // Get selected items from selectedItems state
//     const orderId = order.orderId || order.cartId;
//     const selectedIndexes = selectedItems[orderId] || [];

//     return order.cartItems.filter((item, index) =>
//       selectedIndexes.includes(index)
//     );
//   };

//   // 3. Function to get selected dine-in item IDs
//   const getSelectedDineInItemIds = (order) => {
//     const selectedItemsList = getSelectedDineInItems(order);
//     return selectedItemsList.map(item => item.itemId).filter(id => id);
//   };

//   // 4. Helper to get current stage index
//   const getCurrentStageIndex = (order) => {
//     const stageOrder = ["Placed", "Preparing", "Prepared", "Dispatched", "Delivered"];
//     const statusToStage = {
//       CONFIRMED: "Placed",
//       PROCESSING: "Preparing",      // ← CHANGE from "Placed" to "Preparing"
//       ORDER_IS_READY: "Prepared",   // Keep
//       WAITING_FOR_PICKUP: "Dispatched", // Keep
//       DELIVERED: "Delivered"        // ← CHANGE from COMPLETED to DELIVERED
//     };

//     if (order.orderType === "TABLE_DINE_IN" && Array.isArray(order.cartItems)) {
//       // For dine-in, find the highest completed stage among ALL items
//       const itemStatuses = order.cartItems.map(item => item.orderStatus);
//       let highestStageIndex = 0;

//       itemStatuses.forEach(status => {
//         const stage = statusToStage[status] || "Placed";
//         const stageIndex = stageOrder.indexOf(stage);
//         if (stageIndex > highestStageIndex) {
//           highestStageIndex = stageIndex;
//         }
//       });

//       return highestStageIndex;
//     } else {
//       // For normal orders
//       const currentStage = statusToStage[order.status] || "Placed";
//       return stageOrder.indexOf(currentStage);
//     }
//   };

//   // 5. Function to update normal order status
//   const updateOrderStatus = async (orderId, newStatus) => {
//     const token = localStorage.getItem("authToken");
//     if (!token) {
//       alert("Authentication token missing");
//       return false;
//     }

//     try {
//       // Map UI status to API status values
//       const statusMap = {
//         "Preparing": "PROCESSING",        // ← CHANGE to PROCESSING
//         "Prepared": "ORDER_IS_READY",     // Keep (correct)
//         "Dispatched": "WAITING_FOR_PICKUP", // Keep (correct)
//         "Delivered": "DELIVERED"          // ← CHANGE to DELIVERED
//       };


//       const apiStatus = statusMap[newStatus];

//       const response = await axios.put(
//         `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/${apiStatus}`,
//         { status: apiStatus },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       //console.log(`Order ${orderId} updated to ${apiStatus}:`, response.data);
//       return true;
//     } catch (error) {
//       console.error(`Failed to update order status to ${newStatus}:`, error);
//       alert(`Failed to update status: ${error.response?.data?.message || error.message}`);
//       return false;
//     }
//   };

//   // 6. Function to update TABLE_DINE_IN cart items status
//   const updateDineInItemsStatus = async (cartId, itemIds, newStatus) => {
//     const token = localStorage.getItem("authToken");
//     if (!token) {
//       alert("Authentication token missing");
//       return false;
//     }

//     try {
//       // Map UI status to API status values for dine-in
//       const statusMap = {
//         "Preparing": "PROCESSING",        // ← CHANGE to PROCESSING
//         "Prepared": "ORDER_IS_READY",     // Keep (correct)
//         "Dispatched": "WAITING_FOR_PICKUP", // Keep (correct)
//         "Delivered": "DELIVERED"          // ← CHANGE to DELIVERED
//       };


//       const apiStatus = statusMap[newStatus];
//       const note = "Updated from order lifecycle";

//       if (itemIds.length === 0) {
//         alert("No items selected");
//         return false;
//       }

//       // Join itemIds for batch update
//       const itemIdsParam = itemIds.join("&itemIds=");
//       const url = `https://backend.maamaas.com/food/api/cart/cart/status/${cartId}?itemIds=${itemIdsParam}&status=${apiStatus}&note=${encodeURIComponent(note)}`;

//       const response = await fetch(url, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(`Error ${response.status}: ${errorText}`);
//       }

//       const data = await response.json();
//       //console.log(`Dine-in items updated to ${apiStatus}:`, data);
//       return true;
//     } catch (error) {
//       console.error(`Failed to update dine-in items status to ${newStatus}:`, error);
//       alert(`Failed to update dine-in items: ${error.message}`);
//       return false;
//     }
//   };

//   // 7. Function to handle stage click
//   const handleStageClick = async (order, stage, stageIndex) => {
//     const orderId = order.orderId || order.cartId;

//     // Don't allow clicking on already completed stages
//     const stageOrder = ["Placed", "Preparing", "Prepared", "Dispatched", "Delivered"];
//     const currentStageIndex = getCurrentStageIndex(order);

//     if (stageIndex <= currentStageIndex) {
//       return; // Already completed, no action
//     }

//     // Check if this is the next stage in sequence
//     if (stageIndex !== currentStageIndex + 1) {
//       const nextStage = stageOrder[currentStageIndex + 1];
//       alert(`Please complete "${nextStage}" stage first!`);
//       return;
//     }

//     // Show confirmation
//     // const confirmMessage = order.orderType === "TABLE_DINE_IN"
//     //   ? `Mark ${getSelectedDineInItemIds(order).length} selected items as "${stage}"?`
//     //   : `Mark order #${orderId} as "${stage}"?`;

//     // if (!window.confirm(confirmMessage)) {
//     //   return;
//     // }

//     let success = false;

//     // For TABLE_DINE_IN orders with selected items
//     if (order.orderType === "TABLE_DINE_IN") {
//       const selectedItemIds = getSelectedDineInItemIds(order);
//       if (selectedItemIds.length === 0) {
//         alert("Please select at least one item to update");
//         return;
//       }

//       success = await updateDineInItemsStatus(order.cartId, selectedItemIds, stage);
//     } else {
//       // For normal orders
//       success = await updateOrderStatus(orderId, stage);
//     }

//     if (success) {
//       // Refresh orders after short delay
//       setTimeout(() => {
//         fetchOrders();
//       }, 500);
//     }
//   };
//   // Separate function to export ALL orders
//   const exportAllOrdersForCSV = async () => {
//     if (!vendorId) {
//       alert("No vendor ID found");
//       return;
//     }

//     showLoader();
//     try {
//       const token = localStorage.getItem("authToken");

//       // Fetch ALL orders for export (not paginated)
//       const response = await axios.get(
//         `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       let allOrders = response.data || [];

//       // Apply date filter if selected
//       if (selectedDate) {
//         allOrders = allOrders.filter(order => {
//           if (!order.orderDateAndTime) return false;
//           const orderDate = new Date(order.orderDateAndTime).toISOString().split('T')[0];
//           return orderDate === selectedDate;
//         });
//       }

//       if (allOrders.length === 0) {
//         alert("No data to export!");
//         hideLoader();
//         return;
//       }

//       // Build CSV
//       const headers = ["S.No", "Order ID", "Date", "Category", "Type", "Payment", "Order Status", "Amount"];

//       const rows = allOrders.map((item, index) => [
//         index + 1,
//         item.orderId,
//         new Date(item.orderDateAndTime).toLocaleDateString("en-GB"),
//         "Food",
//         item.orderType || item.orderService,
//         item.paymentMethod === "Online_Payment" ? "Online" : item.paymentMethod,
//         item.status,
//         Math.round(item.grandTotal || 0),
//       ]);

//       const csvContent = [headers, ...rows]
//         .map(row => row.map(v => `"${v}"`).join(","))
//         .join("\n");

//       // Download
//       const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//       const url = URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `orders_${selectedDate || "all"}_${new Date().toISOString().split('T')[0]}.csv`);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//     } catch (error) {
//       console.error("Export error:", error);
//       alert("Failed to export data");
//     } finally {
//       hideLoader();
//     }
//   };

//   const [showDetails, setShowDetails] = useState(false);

//   const orderStages = ["Placed", "Preparing", "Prepared", "Dispatched", "Delivered"];

//   const styles = {
//     card: { border: '1px solid #ccc', padding: '16px', margin: '16px', marginRight: "0px",marginLeft:"0px", borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)", },
//     header: { display: 'flex', justifyContent: 'space-around', },
//     orderId: { margin: 0, fontWeight: "bold" },
//     date: { fontSize: '18px', color: '#000', fontWeight: "bold" },
//     pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold", },
//     tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
//     statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
//     arrow: { margin: '0 5px' },
//     dropdownBtn: {
//       background: 'none',
//       border: 'none',
//       fontSize: '20px',
//       cursor: 'pointer',
//       ...(screenWidth >= 1000 && screenWidth <= 1200 ? { marginLeft: '100px' } : {}), // 👈 conditional style
//     },
//     itemList: { marginTop: '10px', fontWeight: "bold" },
//     itemRow: { display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #ddd' }
//   };
//   // Helper function to get status color
//   const getStatusColor = (status) => {
//     const statusColors = {
//       CONFIRMED: '#607d8b',          // Orange
//       PROCESSING: '#607d8b',         // Blue
//       BEING_PREPARED: '#607d8b',     // Green
//       ORDER_IS_READY: '#607d8b',     // Purple
//       WAITING_FOR_PICKUP: '#607d8b', // Gray
//       COMPLETED: '#607d8b',          // Brown
//     };
//     return statusColors[status] || '#666';
//   };

//   // Helper function to get status text
//   const getStatusText = (status) => {
//     const statusTexts = {
//       CONFIRMED: "Confirmed",
//       PROCESSING: "Placed",
//       BEING_PREPARED: "Preparing",
//       ORDER_IS_READY: "Prepared",
//       WAITING_FOR_PICKUP: "Dispatched",
//       COMPLETED: "Delivered",
//     };
//     return statusTexts[status] || "Processing";
//   };


//   // {=======================overview===============================}
//   const tabContent = {
//     "Order Life-Cycle": <div>
//       {orders.map((order) => {
//         // For TABLE_DINE_IN orders, use cartItems; otherwise use orderItems
//         const orderItems = order.orderType === "TABLE_DINE_IN" ? order.cartItems || [] : order.order || [];
//         const orderId = order.orderId || order.cartId; // fallback for TABLE_DINE_IN
//         const selected = selectedItems[orderId] || [];

//         return (
//           // Replace the header section inside your order mapping
//           <div key={orderId} style={{
//             border: '1px solid #ccc',
//             padding: '16px',
//             margin: '16px',
//             marginRight: "0px",
//             borderRadius: '10px',
//             background: (() => {
//               const normalized = (order.orderType || "").trim().toLowerCase();
//               switch (normalized) {
//                 case "dine_in": return "#1E90FF";
//                 case "takeaway": return "#FF6347";
//                 case "delivery": return "#20B2AA";
//                 case "table_dine_in": return "#2051b2ff";
//                 default: return "#b15cd6";
//               }
//             })(),
//           }}>
//             <div style={styles.header}>
//               {/* Main container with responsive layout */}
//               <div style={{
//                 display: 'flex',
//                 flexDirection: window.innerWidth < 1300 ? 'column' : 'row',
//                 justifyContent: 'space-between',
//                 alignItems: window.innerWidth < 1300 ? 'stretch' : 'center',
//                 gap: window.innerWidth < 1300 ? '10px' : '0',
//                 width: '100%',
//                 padding: '5px 0',
//               }}>

//                 {/* First Line: Order ID and Date/Time - Full width with space-between */}
//                 <div style={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: window.innerWidth <= 500 ? 'start' : 'center',
//                   width: '100%',
//                   flexDirection: window.innerWidth <= 500 ? "column" : "row",
//                   marginLeft: window.innerWidth <= 370 ? "-1rem" : " ",
//                   gap: window.innerWidth <= 370 ? '0px' : '10px',
//                   padding: window.innerWidth < 1300 ? '0 5px' : '0',
//                 }}>
//                   <div style={{
//                     ...styles.orderId,
//                     margin: 0,
//                     fontSize: window.innerWidth <= 370 ? '14px' : '17px',
//                     fontWeight: 'bold',
//                     color: "black",
//                     whiteSpace: 'nowrap',
//                     display: "flex",
//                     justifyContent: "space-between", // This pushes children to opposite ends
//                     alignItems: "center",
//                     width: "100%", // Ensure it takes full width
//                   }}>
//                     {/* Left side - Order ID */}
//                     <div style={{
//                       flex: "0 0 auto", // Don't grow, don't shrink, auto width
//                     }}>
//                       ORDER ID : <span style={{
//                         fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
//                         color: "white"
//                       }}>#{orderId}</span>
//                     </div>

//                     {/* Right side - Order Type button */}
//                     <div style={{
//                       flex: "0 0 auto", // Don't grow, don't shrink, auto width
//                       marginLeft: "10px", // Add some spacing from Order ID
//                     }}>
//                       <button style={{
//                         background: '#28a745',
//                         color: '#fff',
//                         border: 'none',
//                         padding: window.innerWidth < 1100 ? "5px 10px" : '6px 15px',
//                         borderRadius: '4px',
//                         fontWeight: 'bold',
//                         fontSize: '14px',
//                         whiteSpace: 'nowrap',
//                         cursor: 'default',
//                         display:window.innerWidth <=450 ? "block" : "none",
//                       }}>
//                         {order.orderType === 'DINE_IN' ? 'DINEIN' : (order.service || order.orderType || 'Service')}
//                       </button>
//                     </div>
//                   </div>

//                   {/* Date and Time inline */}
//                   {order.orderDateAndTime && (
//                     <div style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       fontSize: window.innerWidth <= 370 ? '14px' : '16px',
//                       color: '#000000ff',
//                       fontWeight: '500',
//                       whiteSpace: 'nowrap',
//                     }}>
//                       <span style={{ whiteSpace: 'nowrap' }}>
//                         {(() => {
//                           const dateObj = new Date(order.orderDateAndTime);
//                           const date = dateObj.toLocaleDateString('en-IN', {
//                             day: '2-digit',
//                             month: 'short',
//                             year: 'numeric',
//                           });
//                           const time = dateObj.toLocaleTimeString('en-IN', {
//                             hour: '2-digit',
//                             minute: '2-digit',
//                             hour12: true,
//                           });
//                           return (
//                             <>
//                               <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: window.innerWidth <= 370 ? '14px' : '17px', }}>DATE:</span>
//                               <span style={{ color: '#ffffffff', marginRight: '10px', marginLeft: "5px", fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem" }}>{date}</span>
//                               <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: window.innerWidth <= 370 ? '14px' : '17px', }}>TIME:</span>
//                               <span style={{ color: '#ffffffff', marginLeft: "5px", fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem" }}>{time}</span>
//                             </>
//                           );
//                         })()}
//                       </span>
//                       <button
//                         style={{
//                           background: 'none',
//                           border: '0px solid #ccc',
//                           borderRadius: '4px',
//                           padding: '6px 12px',
//                           cursor: 'pointer',
//                           fontSize: '14px',
//                           minWidth: '40px',
//                           display: window.innerWidth > 1299 ? "none" : "block",
//                         }}
//                         onClick={() =>
//                           setShowDetails((prev) => ({
//                             ...prev,
//                             [orderId]: !prev[orderId],
//                           }))
//                         }
//                       >
//                         {showDetails[orderId] ? '▲' : '▼'}
//                       </button>
//                     </div>

//                   )}
//                 </div>

//                 {/* Second Line: Order Type, Status, and Dropdown - Aligned to end */}
//                 <div style={{
//                   display: 'flex',
//                   justifyContent: window.innerWidth < 1300 ? 'flex-end' : 'end',
//                   alignItems: 'center',
//                   gap: window.innerWidth >= 1300 && window.innerWidth < 1350 ? '5px' : '15px',
//                   width: '100%',
//                   padding: window.innerWidth < 1300 ? '5px 5px 0 5px' : '0',
//                   flexWrap: 'wrap',
//                 }}>
//                   {/* Order Type */}
//                   <div style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                   }}>
//                     <button style={{
//                       background: '#28a745',
//                       color: '#fff',
//                       border: 'none',
//                       padding: window.innerWidth < 1100 ? "5px 10px" : '6px 15px',
//                       borderRadius: '4px',
//                       fontWeight: 'bold',
//                       fontSize: '14px',
//                       whiteSpace: 'nowrap',
//                       cursor: 'default',
//                       display:window.innerWidth >450 ? "block" : "none",
                      
//                     }}>
//                       {order.orderType === 'DINE_IN' ? 'DINEIN' : (order.service || order.orderType || 'Service')}
//                     </button>
//                   </div>

//                   {/* Status indicator */}
//                   <div style={{
//                     padding: '6px 12px',
//                     backgroundColor: getStatusColor(order.status),
//                     color: 'white',
//                     borderRadius: '4px',
//                     fontSize: '14px',
//                     textTransform: 'uppercase',
//                     whiteSpace: 'nowrap',
//                     minWidth: '100px',
//                     textAlign: 'center',
//                     display:window.innerWidth >450 ? "block" : "none",
//                   }}>
//                     {getStatusText(order.status)}
//                   </div>

//                   {/* Dropdown button */}
//                   <button
//                     style={{
//                       background: 'none',
//                       border: '0px solid #ccc',
//                       borderRadius: '4px',
//                       padding: '6px 12px',
//                       cursor: 'pointer',
//                       fontSize: '14px',
//                       minWidth: '40px',
//                       display: window.innerWidth > 1299 ? "block" : "none",
//                     }}
//                     onClick={() =>
//                       setShowDetails((prev) => ({
//                         ...prev,
//                         [orderId]: !prev[orderId],
//                       }))
//                     }
//                   >
//                     {showDetails[orderId] ? '▲' : '▼'}
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {showDetails[orderId] && (
//               <>
//                 <div style={{ marginTop: window.innerWidth<450 ? '-1rem' : '0rem',margin:window.innerWidth<500 ? "0px 0%" :window.innerWidth>= 1200 ? " 0px 30%" : "0px 15%" }}>
//                   {/* Table with invisible styling */}
//                   <table style={{
//                     width: '100%',
//                     borderCollapse: 'collapse',
//                     border: 'none',
//                     background: 'transparent'
//                   }}>
//                     {/* Table Header - invisible */}
//                     <thead>
//                       <tr style={{
//                         border: 'none',
//                         background: 'transparent'
//                       }}>
//                         <th style={{
//                           textAlign: 'center',
//                           color: 'black',
//                           fontWeight: 'bold',
//                           fontSize: window.innerWidth <= 370 ? '14px' : '17px',
//                           padding: '8px 10px',
//                           paddingBottom: '0px',
//                           border: 'none',
//                           background: 'transparent'
//                         }}>
//                           ITEM
//                         </th>
//                         <th style={{
//                           textAlign:window.innerWidth<450 ? 'center' : 'right',
//                           color: 'black',
//                           fontWeight: 'bold',
//                           fontSize: window.innerWidth <= 370 ? '14px' : '17px',
//                           padding: '8px 10px',
//                           paddingBottom: '0px',
//                           border: 'none',
//                           background: 'transparent'
//                         }}>
//                           QUANTITY
//                         </th>
//                       </tr>
//                     </thead>

//                     {/* Table Body - invisible */}
//                     <tbody>
//                       {orderItems
//                         .filter((item) => item.status === "Okay" || item.orderType === "TABLE_DINE_IN")
//                         .map((item, index) => (
//                           <tr
//                             key={index}
//                             style={{
//                               border: 'none',
//                               background: 'transparent'
//                             }}
//                           >
//                             {/* Item column with checkbox */}
//                             <td style={{
//                               padding: '0px 20px',
//                               paddingTop: '0px',
//                               border: 'none',
//                               background: 'transparent',
//                               display: 'flex',
//                               alignItems: 'center',
//                               gap: '10px'
//                             }}>
//                               <input
//                                 type="checkbox"
//                                 checked={!!selectedItems[item.listId || item.id || index]}
//                                 onChange={() => {
//                                   const id = item.listId || item.id || index;
//                                   setSelectedItems(prev => ({
//                                     ...prev,
//                                     [id]: !prev[id]
//                                   }));
//                                 }}
//                                 style={{
//                                   cursor: 'pointer',
//                                   marginRight: '20px'
//                                 }}
//                               />
//                               <span style={{
//                                 fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
//                                 color: '#ffffffff',
//                                 whiteSpace:"nowrap",
//                               }}>
//                                 {item.dishName}
//                               </span>
//                             </td>

//                             {/* Quantity column */}
//                             <td style={{
//                               padding: '8px 10px',
//                               paddingTop: '0px',
//                               border: 'none',
//                               background: 'transparent',
//                               textAlign:window.innerWidth<450 ? 'center' : 'center',
//                               fontWeight: 'bold',
//                               fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
//                               color: '#ffffffff'
//                             }}>
//                               {item.quantity || 1}
//                             </td>
//                           </tr>
//                         ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </>
//             )}


//             <div style={{
//               ...styles.tracker,
//               display: 'flex',
//               justifyContent: 'center',
//               flexDirection: isMobile ? 'column' : 'row',
//               gap: isMobile ? '5px' : '0px',
//               alignItems: 'center',
//               fontSize: window.innerWidth < 1300 ? "0.9rem" : "1rem",
//             }}>
//               {orderStages.map((stage, index) => {
//                 const stageOrder = orderStages;

//                 // Get current stage index for this order
//                 const currentStageIndex = getCurrentStageIndex(order);

//                 // Determine if stage is completed
//                 const isCompleted = index <= currentStageIndex;

//                 // Determine if stage is clickable (next in sequence)
//                 const isNextStage = index === currentStageIndex + 1;
//                 const hasSelectedItems = order.orderType === "TABLE_DINE_IN"
//                   ? getSelectedDineInItemIds(order).length > 0
//                   : true;
//                 const isClickable = isNextStage && hasSelectedItems;

//                 return (
//                   <React.Fragment key={index}>
//                     <div
//                       onClick={() => isClickable && handleStageClick(order, stage, index)}
//                       style={{
//                         ...styles.statusBox,
//                         backgroundColor: isCompleted ? "green" : isClickable ? " #ffd900ff" : "#f0f0f0ff",
//                         color: isCompleted ? "white" : "black",
//                         borderRadius: "6px",
//                         padding: window.innerWidth < 1100 ? "6px 10px" : "8px 12px",
//                         fontWeight: "bold",
//                         textTransform: "uppercase",
//                         transition: "all 0.3s ease",
//                         cursor: isClickable ? "pointer" : "default",
//                         boxShadow: isClickable ? "0 2px 8px rgba(0,0,0,0.3)" : "none",
//                         position: "relative",
//                         transform: isClickable ? "translateY(-2px)" : "none",
//                         // border: isClickable ? "2px solid #ff4081" : "2px solid transparent",
//                       }}
//                       onMouseEnter={(e) => {
//                         if (isClickable) e.currentTarget.style.transform = "scale(1.05)";
//                       }}
//                       onMouseLeave={(e) => {
//                         if (isClickable) e.currentTarget.style.transform = "translateY(-2px)";
//                       }}
//                       title={isClickable ? `Click to mark as ${stage}` : isCompleted ? `Already ${stage}` : ""}
//                     >
//                       {stage}
//                       {isClickable && (
//                         <span style={{
//                           position: "absolute",
//                           top: "-8px",
//                           right: "-8px",
//                           // background: "#ff4081",
//                           color: "white",
//                           borderRadius: "50%",
//                           width: "24px",
//                           height: "24px",
//                           fontSize: "14px",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           fontWeight: "bold",
//                           animation: "pulse 2s infinite",
//                         }}>

//                         </span>
//                       )}
//                     </div>
//                     {index !== orderStages.length - 1 && <span style={styles.arrow}></span>}
//                   </React.Fragment>
//                 );
//               })}
//             </div>
//           </div>
//         );
//       })}

//     </div >
//     ,
//     Status:
//       <div style={{ scrollbarWidth: 'none', overflow: 'auto' }}>
//         <div className="order-table-container">
//           <style>
//             {`
//         .order-table-container {
//           padding: 0px;
//           font-family: Arial, sans-serif;
//         }
        
//         .pagination-controls {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin: 20px 0;
//           padding: 15px;
//           background: #f8f9fa;
//           border-radius: 8px;
//           flex-wrap: wrap;
//           gap: 10px;
//         }
        
//         .pagination-buttons {
//           display: flex;
//           gap: 10px;
//         }
        
//         .pagination-btn {
//           padding: 8px 20px;
//           background-color: #b15cd6;
//           color: white;
//           border: none;
//           border-radius: 5px;
//           cursor: pointer;
//           font-weight: bold;
//           min-width: 100px;
//           transition: background 0.3s;
//         }
        
//         .pagination-btn:hover:not(:disabled) {
//           background-color: #9a4bc2;
//         }
        
//         .pagination-btn:disabled {
//           background-color: #ccc;
//           cursor: not-allowed;
//         }
        
//         .page-info {
//           font-weight: bold;
//           color: #333;
//           font-size: 14px;
//           text-align: center;
//           flex-grow: 1;
//         }
        
//         .filters {
//           display: flex;
//           justify-content: space-between;
//           align-items: flex-start;
//           flex-wrap: wrap;
//           gap: 10px;
//           margin-bottom: 15px;
//         }
        
//         .filters button {
//           padding: 10px 20px;
//           background-color: #b15cd6;
//           color: #fff;
//           border: none;
//           border-radius: 5px;
//           font-weight: bold;
//           cursor: pointer;
//           white-space: nowrap;
//         }
        
//         .table-wrapper {
//           overflow-x: auto;
//           margin-top: 0px;
//           min-height: 300px;
//           width:94vw;
//         }
        
//         table {
//           width: 100%;
//           border-collapse: collapse;
//           min-width: 800px;
//         }
        
//         thead tr {
//           background-color: #b15cd6;
//         }
        
//         th, td {
//           padding: 10px;
//           border: 1px solid #ddd;
//           text-align: center;
//           font-size: 14px;
//         }
        
//         tbody tr:nth-child(even) {
//           background-color: #f9f9f9;
//         }
        
//         tbody tr:nth-child(odd) {
//           background-color: #ffffff;
//         }
        
//         .loading-spinner {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           padding: 40px;
//         }
        
//         .spinner {
//           width: 40px;
//           height: 40px;
//           border: 4px solid #f3f3f3;
//           border-top: 4px solid #b15cd6;
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//         }
        
//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }
        
//         @media (max-width: 768px) {
//           .pagination-controls {
//             flex-direction: column;
//             text-align: center;
//           }
          
//           .pagination-buttons {
//             width: 100%;
//             justify-content: center;
//           }
          
//           .pagination-btn {
//             flex: 1;
//             max-width: 120px;
//           }
//         }
//       `}
//           </style>

//           {/* Filter Row */}
//           <div className="filters">
//             <div>
//               <button>
//                 <input
//                   type="date"
//                   value={selectedDate}
//                   onChange={(e) => {
//                     setSelectedDate(e.target.value);
//                   }}
//                   style={{
//                     background: "rgb(177 92 214)",
//                     color: "#fff",
//                     border: "none",
//                     padding: "8px"
//                   }}
//                 />
//               </button>
//             </div>
//             <button onClick={() => {
//               // Export function that fetches ALL data separately
//               exportAllOrdersForCSV();
//             }}>
//               Export
//             </button>
//           </div>

//           {/* Loading State */}
//           {isLoadingStatus ? (
//             <div className="loading-spinner">
//               <div className="spinner"></div>
//               <span style={{ marginLeft: '10px', color: '#b15cd6' }}>
//                 Loading orders...
//               </span>
//             </div>
//           ) : (
//             <>
//               {/* Table */}
//               <div className="table-wrapper" style={{width:"94vw"}}>
//                 <table>
//                   <thead>
//                     <tr>
//                       <th>S.No</th>
//                       <th>Order ID</th>
//                       <th>Date</th>
//                       <th>Category</th>
//                       <th>Type</th>
//                       <th>Payment</th>
//                       <th>Order Status</th>
//                       <th>Amount</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {statusOrders.length === 0 ? (
//                       <tr>
//                         <td colSpan="8" style={{ textAlign: "center", padding: "40px" }}>
//                           {selectedDate ? `No orders found for ${selectedDate}` : "No orders found"}
//                         </td>
//                       </tr>
//                     ) : (
//                       statusOrders.map((item, index) => (
//                         <tr key={index}>
//                           <td>{(currentPage * 10) + index + 1}</td>
//                           <td>{item.orderId}</td>

//                           {/* DATE FORMAT dd/mm/yyyy */}
//                           <td>{new Intl.DateTimeFormat("en-GB").format(new Date(item.orderDateAndTime))}</td>

//                           <td>Food</td>
//                           <td>{item.orderType}</td>
//                           <td>{item.paymentMethod}</td>
//                           <td>{item.status}</td>
//                           <td>₹{Math.round(item.grandTotal)}</td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>

//                 {/* ⭐ Pagination Controls — ALWAYS visible if there are orders */}




//               </div>
//             </>
//           )}

//         </div>
//         {statusOrders.length > 0 && (
//           <div className="pagination-buttons"
//             style={{ marginTop: "20px", display: "flex", gap: "10px", justifyContent: "center" }}>

//             {/* Previous */}
//             <button
//               disabled={currentPage === 0}
//               onClick={goPrevious}
//               className="btn btn-primary"
//             >
//               Previous
//             </button>

//             {/* Dynamic Page Numbers */}
//             {getVisiblePages().map((p) => (
//               <button
//                 key={p}
//                 onClick={() => fetchPaginatedOrders(p)}
//                 className={`btn ${currentPage === p ? "btn-primary" : "btn-outline-primary"}`}
//               >
//                 {p}
//               </button>
//             ))}

//             {/* Next */}
//             <button
//               onClick={goNext}
//               className="btn btn-primary"
//             >
//               Next
//             </button>

//           </div>
//         )}
//       </div>


//   };

//   return (

//     <div>

//       <style>{`
//         .main-container {
//           padding: 20px;
//           display: flex;
//           flex-direction: column;
         
//         }
// @media screen and (min-width: 768px) {
//          .tabs-wrapperyyy {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 10px;
//           margin-left:0px;
//           margin-top:-46px;
// }
//       }


// /* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
// @media screen and (max-width: 768px) {
//   .tabs-wrapper {
//     margin-left: 0;
    
//   }
//        .tabs-wrapperyyy {
//       display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 10px;
//           margin-left:0px;
//           margin-top:-30px;
// }
//             .tab-content {
//           width: 100%;
//           max-width:944px;
          
          
//         }
// }


//         .tab-buttons {
//           display: flex;
//           flex-wrap: wrap;
//           justify-content: center;
//           gap: 10px;
//           margin-top:42px;
         
//         }

//         .tab-button {
//           border: none;
//           border-radius: 10px;
//           width: auto;
//           height: 40px;
//           background-color: #d9d9d9;
//           color: #000;
//           font-weight: bold;
//           cursor: pointer;
//           transition: background-color 0.3s ease;
//         }

//         .tab-button.active {
//           background-color: #b15cd6;
//         }

      

//         .sidebar {
//           margin-top: 30px;
//           max-height: 600px;
//           overflow-y: auto;
//         }

//         .card {
//           width: 100%;
//           max-width: 300px;
//           height: 120px;
//           background: #ccc;
//           border-radius: 8px;
//           box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
//           margin: 10px auto;
//           position: relative;
//           padding: 10px;
//         }

//         .card h5, .card p {
//           color: white;
//           margin: -18 !imortanant;
//         }

        

        
//         @media (min-width: 768px) {
//           .main-container {
//             flex-direction: row;
//             justify-content: space-between;
//           }
//   .tab-content {
//           margin-top: 20px;
//           width: 100%;
//           max-width:944px;
          
//         }

//          .left-column {
//     padding-right: 0;
//     display: flex;
//     flex-direction: column;         /* stack children vertically */
           
//     justify-content: center;        /* center vertically */
//     text-align: center;
//     margin: 0 auto;
//   }

//           .right-column {
//             width: 30%;
//             position: sticky;
//             top: -30px;
//             max-height: 700px;
//             overflow-y: auto;
//           }

//           .card {
//             margin-left: 0;
//           }
//             .tabs-wrapperyyy{
//             margin-left:none

//             }

//         }

//         /* Hide native scrollbars */
//         .sidebar::-webkit-scrollbar,
//         .left-column::-webkit-scrollbar {
//           width: 0px;
//           background: transparent;
//         }

        
// /* Media queries for different screen heights */
// @media (max-height: 400px) {
//   .tab-content {
//     height: 50vh !important;
//   }
// }

// @media (min-height: 401px) and (max-height: 500px) {
//   .tab-content {
//     height: 50vh !important;
//   }
// }

// @media (min-height: 501px) and (max-height: 600px) {
//   .tab-content {
//     height: 50vh !important;
//   }
// }

// /* For screens taller than 600px */
// @media (min-height: 601px)and (max-height: 700px) {
//   .tab-content {
//     height: 55vh !important; /* Or use your containerHeight value */
//   }
// }
//   @media (min-height : 701px){
//   .tab-content {
//     height: 60vh !important; /* Or use your containerHeight value */
//   }
//   }
//       `}</style>

//       <div className="container-fluid">
//         <div className="row">
//           {/* <div className="col-lg-2 col-md-12 col-sm-12 col-12"></div> */}
//           <div className="col-lg-12 col-md-12 col-sm-12 col-12">


//             {/* Left Section */}
//             <div className="left-column" style={{}}>
//               <div className="tabs-wrapperyyy ">

//                 <div className="tab-buttons" style={{}}>
//                   {Object.keys(tabContent).map((label) => (
//                     <button
//                       key={label}
//                       className={`tab-button ${activeTab === label ? "active" : ""}`}
//                       onClick={() => setActiveTab(label)}
//                     >
//                       {label}
//                     </button>
//                   ))}
//                 </div>
//                 <div className="tab-content" style={{
//                   overflow: 'auto',
//                   scrollbarWidth: "thin",
//                   msOverflowStyle: "none", maxWidth: '944px',
//                 }}>{tabContent[activeTab]}</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>


//   );
// };

// export default Standardorder;








import React, { useEffect, useState } from 'react';
import './Management.css';
import { FaTrash, FaEye } from 'react-icons/fa'; // Trash and View icon
import axios from 'axios';
import { useLoader } from '../../../../context/LoaderProvider';

// import './Management3.css'



const Standardorder = () => {
  const [activeTab, setActiveTab] = useState('Order Life-Cycle');
  const [data, setData] = useState([]);
  const [orders, setOrders] = useState([]);
  const { showLoader, hideLoader } = useLoader();
  const [loading, setLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const [vendorId, setVendorId] = useState(null);
  const [allOrders, setAllOrders] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(""); // format: YYYY-MM-DD
  const screenWidth = window.innerWidth;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  // Add these with your other useState declarations:
  const [statusOrders, setStatusOrders] = useState([]); // Only current page orders
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize] = useState(10); // Fixed at 10
  const [totalElements, setTotalElements] = useState(0);
  const [isLoadingStatus, setIsLoadingStatus] = useState(false);
  const [filteredOrders, setFilteredOrders] = useState([]);


  const containerHeight = window.innerWidth < 768
    ? '300px'       // Mobile
    : window.innerWidth < 850
      ? '300px'     // Below 850px
      : window.innerWidth < 1400
        ? '410px'   // Between 850px and 1399px
        : window.innerWidth < 1600
          ? '480px' // Between 1400px and 1599px
          : '640px'; // Above 1600px






  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  useEffect(() => {
    let filtered = [...statusOrders];

    if (selectedDate) {
      const s = new Date(selectedDate);
      s.setHours(0, 0, 0, 0);

      const e = new Date(selectedDate);
      e.setHours(23, 59, 59, 999);

      filtered = filtered.filter(order => {
        const date = new Date(order.orderDateAndTime);
        return date >= s && date <= e;
      });
    }

    setFilteredOrders(filtered);
  }, [selectedDate, statusOrders]);

  // Fetch orders from API
  useEffect(() => {
    if (!vendorId) return;

    const fetchOrders = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("Authorization token missing");
        return;
      }

      try {
        let pageIndex = 0;
        let allNormalOrders = [];
        let morePages = true;

        // 🔵 Fetch ALL PAGINATED ORDERS page by page
        while (morePages) {
          const res = await axios.get(
            `https://backend.maamaas.com/food/api/orders/vendor/paginated/${vendorId}/${pageIndex}/10`,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          const response = res.data;

          if (!response || !Array.isArray(response.content)) break;

          const pageData = response.content;

          if (pageData.length === 0) break;

          allNormalOrders = [...allNormalOrders, ...pageData];

          if (pageData.length < 10) {
            morePages = false;
          } else {
            pageIndex++;
          }
        }

        // 🔵 Fetch DINE-IN completed orders
        const dineInRes = await axios.get(
          `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/COMPLETED`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const dineInRaw = dineInRes.data || [];

        const dineInOrders = dineInRaw.map((order) => ({
          orderId: order.cartId,
          orderDateAndTime: order.cartDateAndTime || new Date().toISOString(),
          appType: "Food",
          orderService: order.orderType,
          userName: order.userName || "Dine-In User",
          paymentMethod: order.paymentMethod || "N/A",
          status: "COMPLETED",
          grandTotal: order.grandTotal || 0,
        }));

        // 🔥 Combine both
        const allData = [...allNormalOrders, ...dineInOrders];

        console.log("ALL COMBINED ORDERS:", allData);

        setAllOrders(allData);
        setFilteredData(allData); // initial display

      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    fetchOrders();
  }, [vendorId]);

  const [allFilteredOrders, setAllFilteredOrders] = useState([]);

  // Filter orders whenever selectedDate changes
  useEffect(() => {
    if (!selectedDate) {
      setAllFilteredOrders(allOrders);
    } else {
      const filtered = allOrders.filter((order) => {
        const orderDate = new Date(order.orderDateAndTime)
          .toISOString()
          .split("T")[0];
        return orderDate === selectedDate;
      });
      setAllFilteredOrders(filtered);
    }
  }, [selectedDate, allOrders]);

  // Then update pagination based on allFilteredOrders
  useEffect(() => {
    if (allFilteredOrders.length > 0) {
      const startIndex = currentPage * 10;
      const pageOrders = allFilteredOrders.slice(startIndex, startIndex + 10);

      const formatted = pageOrders.map(order => ({
        orderId: order.orderId,
        orderDateAndTime: order.orderDateAndTime,
        orderType: order.orderType?.replace(/[_-]/g, "") ?? "N/A",
        paymentMethod: order.paymentMethod?.replace(/[_-]/g, "") ?? "N/A",
        status: order.status,
        grandTotal: order.grandTotal ?? 0,
      }));

      setStatusOrders(formatted);
      setTotalPages(Math.ceil(allFilteredOrders.length / 10));
    }
  }, [allFilteredOrders, currentPage]);




  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId);
    }
  }, []);
  useEffect(() => {
    if (!vendorId) return;

    fetchOrders(); // Initial fetch

    const intervalId = setInterval(fetchOrders, 5000); // Poll every 5 seconds
    return () => clearInterval(intervalId);
  }, [vendorId]);

  const [combinedData, setCombinedData] = useState([]);

  useEffect(() => {
    if (!vendorId) return;

    const fetchData = () => {
      const token = localStorage.getItem("authToken"); // ✅ Retrieve token from storage
      if (!token) {
        console.warn("No auth token found. Skipping fetch.");
        return;
      }

      axios
        .get(
          `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // ✅ Include token in header
            },
          }
        )
        .then((res) => setData(res.data))
        .catch((err) =>
          console.error("Error fetching orders with token:", err.response?.data || err.message)
        );
    };

    fetchData(); // initial fetch

    const interval = setInterval(fetchData, 100000); // fetch every 1 second

    return () => clearInterval(interval); // cleanup
  }, [vendorId]);


  // Fetch paginated orders - 10 per page
  // Fetch paginated orders for Status tab ONLY
  const fetchPaginatedOrders = async (page = 0) => {
    if (!vendorId) return;

    setIsLoadingStatus(true);
    const token = localStorage.getItem("authToken");

    try {
      // OPTION 1: If your API has a non-paginated endpoint (RECOMMENDED)
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`, // Non-paginated endpoint
        { headers: { Authorization: `Bearer ${token}` } }
      );

      let allOrders = response.data || [];


      // Apply date filter if selected
      if (selectedDate) {
        allOrders = allOrders.filter(order => {
          return order.orderDateAndTime?.split("T")[0] === selectedDate;
        });
      }

      // Sort by date (most recent first)
      allOrders.sort((a, b) => new Date(b.orderDateAndTime) - new Date(a.orderDateAndTime));

      // Calculate pagination
      const totalCount = allOrders.length;
      const totalPages = Math.ceil(totalCount / 10); // 10 orders per page


      // Get current page data (10 orders per page)
      const startIndex = page * 10;
      const endIndex = startIndex + 10;
      const pageOrders = allOrders.slice(startIndex, endIndex);


      const formatted = pageOrders.map(order => ({
        orderId: order.orderId,
        orderDateAndTime: order.orderDateAndTime,
        orderType: order.orderType?.replace(/[_-]/g, "") ?? "N/A",
        paymentMethod: order.paymentMethod?.replace(/[_-]/g, "") ?? "N/A",
        status: order.status,
        grandTotal: order.grandTotal ?? 0,
      }));

      setStatusOrders(formatted);
      setTotalPages(totalPages);
      setTotalElements(totalCount);
      setCurrentPage(page);

    } catch (err) {
      console.error("❌ Error fetching orders:", err);

      // OPTION 2: Fallback to paginated API if non-paginated fails
      try {
        console.log("Trying paginated API as fallback...");
        const paginatedResponse = await axios.get(
          `https://backend.maamaas.com/food/api/orders/vendor/paginated/${vendorId}/${page}/10`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        let orders = [];
        let pages = 1;

        if (paginatedResponse.data?.content) {
          orders = paginatedResponse.data.content;
          pages = paginatedResponse.data.totalPages || 1;
          console.log("Using paginated API, totalPages:", pages);
        } else if (Array.isArray(paginatedResponse.data)) {
          orders = paginatedResponse.data;
          pages = Math.ceil(paginatedResponse.data.length / 10);
        }

        const formatted = orders.map(order => ({
          orderId: order.orderId,
          orderDateAndTime: order.orderDateAndTime,
          orderType: order.orderType?.replace(/[_-]/g, "") ?? "N/A",
          paymentMethod: order.paymentMethod?.replace(/[_-]/g, "") ?? "N/A",
          status: order.status,
          grandTotal: order.grandTotal ?? 0,
        }));

        setStatusOrders(formatted);
        setTotalPages(pages);
        setCurrentPage(page);

      } catch (fallbackError) {
        console.error("❌ Both API methods failed:", fallbackError);
      }
    } finally {
      setIsLoadingStatus(false);
    }
  };


  const goNext = () => {
    if (currentPage < totalPages - 1) {
      fetchPaginatedOrders(currentPage + 1);
    }
  };

  const goPrevious = () => {
    if (currentPage > 0) {
      fetchPaginatedOrders(currentPage - 1);
    }
  };

  const getVisiblePages = () => {
    const pages = [];

    // Always show current page
    pages.push(currentPage);

    // Show previous page if exists
    if (currentPage - 1 >= 0) {
      pages.unshift(currentPage - 1); // Add to beginning
    }

    // Show next page if exists
    if (currentPage + 1 < totalPages) {
      pages.push(currentPage + 1);
    }

    return pages.sort((a, b) => a - b); // Ensure ascending order
  };



  // Fetch initial data when component loads
  // Fetch paginated orders when vendorId is available
  useEffect(() => {
    if (vendorId && activeTab === 'Status') {
      fetchPaginatedOrders(0); // Start with page 0
    }
  }, [vendorId, activeTab]);

  // Refetch when date changes
  useEffect(() => {
    if (vendorId && activeTab === 'Status') {
      setCurrentPage(0); // Reset to first page
      fetchPaginatedOrders(0); // Fetch with new date filter
    }
  }, [selectedDate, activeTab]);

  // Add these functions inside your Standardorder component (after useState declarations)

  // 1. Fetch orders function
  const fetchOrders = async () => {
    if (!vendorId) return;

    const token = localStorage.getItem("authToken");
    if (!token) {
      console.warn("Auth token missing. Skipping order fetch.");
      return;
    }

    try {
      // 1️⃣ Fetch normal orders
      const ordersRes = await axios.get(
        `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // ✅ CRITICAL FIX: Include BEING_PREPARED
      const processingOrders = ordersRes.data.filter(order =>
        ["CONFIRMED", "PROCESSING", "ORDER_IS_READY", "WAITING_FOR_PICKUP"].includes(order.status)
      );

      // 2️⃣ Fetch TABLE_DINE_IN orders for relevant statuses
      const dineInStatuses = ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"];
      const dineInPromises = dineInStatuses.map(status =>
        axios.get(
          `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/${status}`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
      );

      const dineInResponses = await Promise.all(dineInPromises);
      let dineInOrders = dineInResponses.flatMap(res => res.data || []);

      // Filter TABLE_DINE_IN orders by cartItems status
      dineInOrders = dineInOrders.filter(order =>
        Array.isArray(order.cartItems) &&
        order.cartItems.some(item =>
          ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"].includes(item.orderStatus)
        )
      );

      // 3️⃣ Combine and deduplicate
      const combinedOrders = [...processingOrders, ...dineInOrders];
      const uniqueOrders = combinedOrders.filter(
        (order, index, self) =>
          index === self.findIndex(
            o => (o.cartId && o.cartId === order.cartId) || (o.orderId && o.orderId === order.orderId)
          )
      );

      console.log("📦 Orders in Order Life-Cycle:", uniqueOrders.length);
      setOrders(uniqueOrders);
    } catch (error) {
      console.error("❌ Failed to fetch orders:", error.response?.data || error.message);
    }
  };

  // 2. Helper to get selected dine-in items
  const getSelectedDineInItems = (order) => {
    if (!order.cartItems || order.orderType !== "TABLE_DINE_IN") return [];

    // Get selected items from selectedItems state
    const orderId = order.orderId || order.cartId;
    const selectedIndexes = selectedItems[orderId] || [];

    return order.cartItems.filter((item, index) =>
      selectedIndexes.includes(index)
    );
  };

  // 3. Function to get selected dine-in item IDs
  const getSelectedDineInItemIds = (order) => {
    const selectedItemsList = getSelectedDineInItems(order);
    return selectedItemsList.map(item => item.itemId).filter(id => id);
  };

  // 4. Helper to get current stage index
  const getCurrentStageIndex = (order) => {
    const stageOrder = ["Placed", "Preparing", "Prepared", "Dispatched", "Delivered"];
    const statusToStage = {
      CONFIRMED: "Placed",
      PROCESSING: "Preparing",      // ← CHANGE from "Placed" to "Preparing"
      ORDER_IS_READY: "Prepared",   // Keep
      WAITING_FOR_PICKUP: "Dispatched", // Keep
      DELIVERED: "Delivered"        // ← CHANGE from COMPLETED to DELIVERED
    };

    if (order.orderType === "TABLE_DINE_IN" && Array.isArray(order.cartItems)) {
      // For dine-in, find the highest completed stage among ALL items
      const itemStatuses = order.cartItems.map(item => item.orderStatus);
      let highestStageIndex = 0;

      itemStatuses.forEach(status => {
        const stage = statusToStage[status] || "Placed";
        const stageIndex = stageOrder.indexOf(stage);
        if (stageIndex > highestStageIndex) {
          highestStageIndex = stageIndex;
        }
      });

      return highestStageIndex;
    } else {
      // For normal orders
      const currentStage = statusToStage[order.status] || "Placed";
      return stageOrder.indexOf(currentStage);
    }
  };

  // 5. Function to update normal order status
  const updateOrderStatus = async (orderId, newStatus) => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("Authentication token missing");
      return false;
    }

    try {
      // Map UI status to API status values
      const statusMap = {
        "Preparing": "PROCESSING",        // ← CHANGE to PROCESSING
        "Prepared": "ORDER_IS_READY",     // Keep (correct)
        "Dispatched": "WAITING_FOR_PICKUP", // Keep (correct)
        "Delivered": "DELIVERED"          // ← CHANGE to DELIVERED
      };


      const apiStatus = statusMap[newStatus];

      const response = await axios.put(
        `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/${apiStatus}`,
        { status: apiStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      console.log(`Order ${orderId} updated to ${apiStatus}:`, response.data);
      return true;
    } catch (error) {
      console.error(`Failed to update order status to ${newStatus}:`, error);
      alert(`Failed to update status: ${error.response?.data?.message || error.message}`);
      return false;
    }
  };

  // 6. Function to update TABLE_DINE_IN cart items status
  const updateDineInItemsStatus = async (cartId, itemIds, newStatus) => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("Authentication token missing");
      return false;
    }

    try {
      // Map UI status to API status values for dine-in
      const statusMap = {
        "Preparing": "PROCESSING",        // ← CHANGE to PROCESSING
        "Prepared": "ORDER_IS_READY",     // Keep (correct)
        "Dispatched": "WAITING_FOR_PICKUP", // Keep (correct)
        "Delivered": "DELIVERED"          // ← CHANGE to DELIVERED
      };


      const apiStatus = statusMap[newStatus];
      const note = "Updated from order lifecycle";

      if (itemIds.length === 0) {
        alert("No items selected");
        return false;
      }

      // Join itemIds for batch update
      const itemIdsParam = itemIds.join("&itemIds=");
      const url = `https://backend.maamaas.com/food/api/cart/cart/status/${cartId}?itemIds=${itemIdsParam}&status=${apiStatus}&note=${encodeURIComponent(note)}`;

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      console.log(`Dine-in items updated to ${apiStatus}:`, data);
      return true;
    } catch (error) {
      console.error(`Failed to update dine-in items status to ${newStatus}:`, error);
      alert(`Failed to update dine-in items: ${error.message}`);
      return false;
    }
  };

  // 7. Function to handle stage click
  const handleStageClick = async (order, stage, stageIndex) => {
    const orderId = order.orderId || order.cartId;

    // Don't allow clicking on already completed stages
    const stageOrder = ["Placed", "Preparing", "Prepared", "Dispatched", "Delivered"];
    const currentStageIndex = getCurrentStageIndex(order);

    if (stageIndex <= currentStageIndex) {
      return; // Already completed, no action
    }

    // Check if this is the next stage in sequence
    if (stageIndex !== currentStageIndex + 1) {
      const nextStage = stageOrder[currentStageIndex + 1];
      alert(`Please complete "${nextStage}" stage first!`);
      return;
    }

    // Show confirmation
    // const confirmMessage = order.orderType === "TABLE_DINE_IN"
    //   ? `Mark ${getSelectedDineInItemIds(order).length} selected items as "${stage}"?`
    //   : `Mark order #${orderId} as "${stage}"?`;

    // if (!window.confirm(confirmMessage)) {
    //   return;
    // }

    let success = false;

    // For TABLE_DINE_IN orders with selected items
    if (order.orderType === "TABLE_DINE_IN") {
      const selectedItemIds = getSelectedDineInItemIds(order);
      if (selectedItemIds.length === 0) {
        alert("Please select at least one item to update");
        return;
      }

      success = await updateDineInItemsStatus(order.cartId, selectedItemIds, stage);
    } else {
      // For normal orders
      success = await updateOrderStatus(orderId, stage);
    }

    if (success) {
      // Refresh orders after short delay
      setTimeout(() => {
        fetchOrders();
      }, 500);
    }
  };
  // Separate function to export ALL orders
  const exportAllOrdersForCSV = async () => {
    if (!vendorId) {
      alert("No vendor ID found");
      return;
    }

    showLoader();
    try {
      const token = localStorage.getItem("authToken");

      // Fetch ALL orders for export (not paginated)
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      let allOrders = response.data || [];

      // Apply date filter if selected
      if (selectedDate) {
        allOrders = allOrders.filter(order => {
          if (!order.orderDateAndTime) return false;
          const orderDate = new Date(order.orderDateAndTime).toISOString().split('T')[0];
          return orderDate === selectedDate;
        });
      }

      if (allOrders.length === 0) {
        alert("No data to export!");
        hideLoader();
        return;
      }

      // Build CSV
      const headers = ["S.No", "Order ID", "Date", "Category", "Type", "Payment", "Order Status", "Amount"];

      const rows = allOrders.map((item, index) => [
        index + 1,
        item.orderId,
        new Date(item.orderDateAndTime).toLocaleDateString("en-GB"),
        "Food",
        item.orderType || item.orderService,
        item.paymentMethod === "Online_Payment" ? "Online" : item.paymentMethod,
        item.status,
        Math.round(item.grandTotal || 0),
      ]);

      const csvContent = [headers, ...rows]
        .map(row => row.map(v => `"${v}"`).join(","))
        .join("\n");

      // Download
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `orders_${selectedDate || "all"}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error("Export error:", error);
      alert("Failed to export data");
    } finally {
      hideLoader();
    }
  };

  const [showDetails, setShowDetails] = useState(false);

  const orderStages = ["Placed", "Preparing", "Prepared", "Dispatched", "Delivered"];

  const styles = {
    card: { border: '1px solid #ccc', padding: '16px', margin: '16px', marginRight: "0px", marginLeft: "0px", borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)", },
    header: { display: 'flex', justifyContent: 'space-around', },
    orderId: { margin: 0, fontWeight: "bold" },
    date: { fontSize: '18px', color: '#000', fontWeight: "bold" },
    pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold", },
    tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
    statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
    arrow: { margin: '0 5px' },
    dropdownBtn: {
      background: 'none',
      border: 'none',
      fontSize: '20px',
      cursor: 'pointer',
      ...(screenWidth >= 1000 && screenWidth <= 1200 ? { marginLeft: '100px' } : {}), // 👈 conditional style
    },
    itemList: { marginTop: '10px', fontWeight: "bold" },
    itemRow: { display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #ddd' }
  };
  // Helper function to get status color
  const getStatusColor = (status) => {
    const statusColors = {
      CONFIRMED: '#607d8b',          // Orange
      PROCESSING: '#607d8b',         // Blue
      BEING_PREPARED: '#607d8b',     // Green
      ORDER_IS_READY: '#607d8b',     // Purple
      WAITING_FOR_PICKUP: '#607d8b', // Gray
      COMPLETED: '#607d8b',          // Brown
    };
    return statusColors[status] || '#666';
  };

  // Helper function to get status text
  const getStatusText = (status) => {
    const statusTexts = {
      CONFIRMED: "Confirmed",
      PROCESSING: "Placed",
      BEING_PREPARED: "Preparing",
      ORDER_IS_READY: "Prepared",
      WAITING_FOR_PICKUP: "Dispatched",
      COMPLETED: "Delivered",
    };
    return statusTexts[status] || "Processing";
  };
  useEffect(() => {
    console.log("Current totalPages:", totalPages, "Orders count:", statusOrders.length);
  }, [totalPages, statusOrders]);


  // {=======================overview===============================}
  const tabContent = {
    "Order Life-Cycle": (<div style={{
      overflow: 'auto',
      scrollbarWidth: "thin",
      msOverflowStyle: "none",
      maxHeight: '65vh', // Adjust height as needed
      WebkitOverflowScrolling: 'touch'
    }}>
      {orders.map((order) => {
        // For TABLE_DINE_IN orders, use cartItems; otherwise use orderItems
        const orderItems = order.orderType === "TABLE_DINE_IN" ? order.cartItems || [] : order.order || [];
        const orderId = order.orderId || order.cartId; // fallback for TABLE_DINE_IN
        const selected = selectedItems[orderId] || [];

        return (
          // Replace the header section inside your order mapping
          <div key={orderId} style={{
            border: '1px solid #ccc',
            padding: '16px',
            margin: '16px',
            marginRight: "0px",
            borderRadius: '10px',
            background: (() => {
              const normalized = (order.orderType || "").trim().toLowerCase();
              switch (normalized) {
                case "dine_in": return "#1E90FF";
                case "takeaway": return "#FF6347";
                case "delivery": return "#20B2AA";
                case "table_dine_in": return "#2051b2ff";
                default: return "#b15cd6";
              }
            })(),
          }}>
            <div style={styles.header}>
              {/* Main container with responsive layout */}
              <div style={{
                display: 'flex',
                flexDirection: window.innerWidth < 1300 ? 'column' : 'row',
                justifyContent: 'space-between',
                alignItems: window.innerWidth < 1300 ? 'stretch' : 'center',
                gap: window.innerWidth < 1300 ? '10px' : '0',
                width: '100%',
                padding: '5px 0',

              }}>

                {/* First Line: Order ID and Date/Time - Full width with space-between */}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: window.innerWidth <= 500 ? 'start' : 'center',
                  width: '100%',
                  flexDirection: window.innerWidth <= 500 ? "column" : "row",
                  marginLeft: window.innerWidth <= 370 ? "-1rem" : " ",
                  gap: window.innerWidth <= 370 ? '0px' : '10px',
                  padding: window.innerWidth < 1300 ? '0 5px' : '0',
                }}>
                  <div style={{
                    ...styles.orderId,
                    margin: 0,
                    fontSize: window.innerWidth <= 370 ? '14px' : '17px',
                    fontWeight: 'bold',
                    color: "black",
                    whiteSpace: 'nowrap',
                    display: "flex",
                    justifyContent: "space-between", // This pushes children to opposite ends
                    alignItems: "center",
                    width: "100%", // Ensure it takes full width
                  }}>
                    {/* Left side - Order ID */}
                    <div style={{
                      flex: "0 0 auto", // Don't grow, don't shrink, auto width
                    }}>
                      ORDER ID : <span style={{
                        fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
                        color: "white"
                      }}>#{orderId}</span>
                    </div>

                    {/* Right side - Order Type button */}
                    <div style={{
                      flex: "0 0 auto", // Don't grow, don't shrink, auto width
                      marginLeft: "10px", // Add some spacing from Order ID
                    }}>
                      <button style={{
                        background: '#28a745',
                        color: '#fff',
                        border: 'none',
                        padding: window.innerWidth < 1100 ? "5px 10px" : '6px 15px',
                        borderRadius: '4px',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        whiteSpace: 'nowrap',
                        cursor: 'default',
                        display: window.innerWidth <= 450 ? "block" : "none",
                      }}>
                        {order.orderType === 'DINE_IN' ? 'DINEIN' : (order.service || order.orderType || 'Service')}
                      </button>
                    </div>
                  </div>

                  {/* Date and Time inline */}
                  {order.orderDateAndTime && (
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: window.innerWidth <= 370 ? '14px' : '16px',
                      color: '#000000ff',
                      fontWeight: '500',
                      whiteSpace: 'nowrap',
                    }}>
                      <span style={{ whiteSpace: 'nowrap' }}>
                        {(() => {
                          const dateObj = new Date(order.orderDateAndTime);
                          const date = dateObj.toLocaleDateString('en-IN', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                          });
                          const time = dateObj.toLocaleTimeString('en-IN', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true,
                          });
                          return (
                            <>
                              <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: window.innerWidth <= 370 ? '14px' : '17px', }}>DATE:</span>
                              <span style={{ color: '#ffffffff', marginRight: '10px', marginLeft: "5px", fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem" }}>{date}</span>
                              <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: window.innerWidth <= 370 ? '14px' : '17px', }}>TIME:</span>
                              <span style={{ color: '#ffffffff', marginLeft: "5px", fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem" }}>{time}</span>
                            </>
                          );
                        })()}
                      </span>
                      <button
                        style={{
                          background: 'none',
                          border: '0px solid #ccc',
                          borderRadius: '4px',
                          padding: '6px 12px',
                          cursor: 'pointer',
                          fontSize: '14px',
                          minWidth: '40px',
                          display: window.innerWidth > 1299 ? "none" : "block",
                        }}
                        onClick={() =>
                          setShowDetails((prev) => ({
                            ...prev,
                            [orderId]: !prev[orderId],
                          }))
                        }
                      >
                        {showDetails[orderId] ? '▲' : '▼'}
                      </button>
                    </div>

                  )}
                </div>

                {/* Second Line: Order Type, Status, and Dropdown - Aligned to end */}
                <div style={{
                  display: 'flex',
                  justifyContent: window.innerWidth < 1300 ? 'flex-end' : 'end',
                  alignItems: 'center',
                  gap: window.innerWidth >= 1300 && window.innerWidth < 1350 ? '5px' : '15px',
                  width: '100%',
                  padding: window.innerWidth < 1300 ? '5px 5px 0 5px' : '0',
                  flexWrap: 'wrap',
                }}>
                  {/* Order Type */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                    <button style={{
                      background: '#28a745',
                      color: '#fff',
                      border: 'none',
                      padding: window.innerWidth < 1100 ? "5px 10px" : '6px 15px',
                      borderRadius: '4px',
                      fontWeight: 'bold',
                      fontSize: '14px',
                      whiteSpace: 'nowrap',
                      cursor: 'default',
                      display: window.innerWidth > 450 ? "block" : "none",

                    }}>
                      {order.orderType === 'DINE_IN' ? 'DINEIN' : (order.service || order.orderType || 'Service')}
                    </button>
                  </div>

                  {/* Status indicator */}
                  <div style={{
                    padding: '6px 12px',
                    backgroundColor: getStatusColor(order.status),
                    color: 'white',
                    borderRadius: '4px',
                    fontSize: '14px',
                    textTransform: 'uppercase',
                    whiteSpace: 'nowrap',
                    minWidth: '100px',
                    textAlign: 'center',
                    display: window.innerWidth > 450 ? "block" : "none",
                  }}>
                    {getStatusText(order.status)}
                  </div>

                  {/* Dropdown button */}
                  <button
                    style={{
                      background: 'none',
                      border: '0px solid #ccc',
                      borderRadius: '4px',
                      padding: '6px 12px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      minWidth: '40px',
                      display: window.innerWidth > 1299 ? "block" : "none",
                    }}
                    onClick={() =>
                      setShowDetails((prev) => ({
                        ...prev,
                        [orderId]: !prev[orderId],
                      }))
                    }
                  >
                    {showDetails[orderId] ? '▲' : '▼'}
                  </button>
                </div>
              </div>
            </div>

            {showDetails[orderId] && (
              <>
                <div style={{ marginTop: window.innerWidth < 450 ? '-1rem' : '0rem', margin: window.innerWidth < 500 ? "0px 0%" : window.innerWidth >= 1200 ? " 0px 30%" : "0px 15%" }}>
                  {/* Table with invisible styling */}
                  <table style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    border: 'none',
                    background: 'transparent'
                  }}>
                    {/* Table Header - invisible */}
                    <thead>
                      <tr style={{
                        border: 'none',
                        background: 'transparent'
                      }}>
                        <th style={{
                          textAlign: 'center',
                          color: 'black',
                          fontWeight: 'bold',
                          fontSize: window.innerWidth <= 370 ? '14px' : '17px',
                          padding: '8px 10px',
                          paddingBottom: '0px',
                          border: 'none',
                          background: 'transparent'
                        }}>
                          ITEM
                        </th>
                        <th style={{
                          textAlign: window.innerWidth < 450 ? 'center' : 'right',
                          color: 'black',
                          fontWeight: 'bold',
                          fontSize: window.innerWidth <= 370 ? '14px' : '17px',
                          padding: '8px 10px',
                          paddingBottom: '0px',
                          border: 'none',
                          background: 'transparent'
                        }}>
                          QUANTITY
                        </th>
                      </tr>
                    </thead>

                    {/* Table Body - invisible */}
                    <tbody>
                      {orderItems
                        .filter((item) => item.status === "Okay" || item.orderType === "TABLE_DINE_IN")
                        .map((item, index) => (
                          <tr
                            key={index}
                            style={{
                              border: 'none',
                              background: 'transparent'
                            }}
                          >
                            {/* Item column with checkbox */}
                            <td style={{
                              padding: '0px 20px',
                              paddingTop: '0px',
                              border: 'none',
                              background: 'transparent',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px'
                            }}>
                              <input
                                type="checkbox"
                                checked={!!selectedItems[item.listId || item.id || index]}
                                onChange={() => {
                                  const id = item.listId || item.id || index;
                                  setSelectedItems(prev => ({
                                    ...prev,
                                    [id]: !prev[id]
                                  }));
                                }}
                                style={{
                                  cursor: 'pointer',
                                  marginRight: '20px'
                                }}
                              />
                              <span style={{
                                fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
                                color: '#ffffffff',
                                whiteSpace: "nowrap",
                              }}>
                                {item.dishName}
                              </span>
                            </td>

                            {/* Quantity column */}
                            <td style={{
                              padding: '8px 10px',
                              paddingTop: '0px',
                              border: 'none',
                              background: 'transparent',
                              textAlign: window.innerWidth < 450 ? 'center' : 'center',
                              fontWeight: 'bold',
                              fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
                              color: '#ffffffff'
                            }}>
                              {item.quantity || 1}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}


            <div style={{
              ...styles.tracker,
              display: 'flex',
              justifyContent: 'center',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? '5px' : '0px',
              alignItems: 'center',
              fontSize: window.innerWidth < 1300 ? "0.9rem" : "1rem",
            }}>
              {orderStages.map((stage, index) => {
                const stageOrder = orderStages;

                // Get current stage index for this order
                const currentStageIndex = getCurrentStageIndex(order);

                // Determine if stage is completed
                const isCompleted = index <= currentStageIndex;

                // Determine if stage is clickable (next in sequence)
                const isNextStage = index === currentStageIndex + 1;
                const hasSelectedItems = order.orderType === "TABLE_DINE_IN"
                  ? getSelectedDineInItemIds(order).length > 0
                  : true;
                const isClickable = isNextStage && hasSelectedItems;

                return (
                  <React.Fragment key={index}>
                    <div
                      onClick={() => isClickable && handleStageClick(order, stage, index)}
                      style={{
                        ...styles.statusBox,
                        backgroundColor: isCompleted ? "green" : isClickable ? " #ffd900ff" : "#f0f0f0ff",
                        color: isCompleted ? "white" : "black",
                        borderRadius: "6px",
                        padding: window.innerWidth < 1100 ? "6px 10px" : "8px 12px",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        transition: "all 0.3s ease",
                        cursor: isClickable ? "pointer" : "default",
                        boxShadow: isClickable ? "0 2px 8px rgba(0,0,0,0.3)" : "none",
                        position: "relative",
                        transform: isClickable ? "translateY(-2px)" : "none",
                        // border: isClickable ? "2px solid #ff4081" : "2px solid transparent",
                      }}
                      onMouseEnter={(e) => {
                        if (isClickable) e.currentTarget.style.transform = "scale(1.05)";
                      }}
                      onMouseLeave={(e) => {
                        if (isClickable) e.currentTarget.style.transform = "translateY(-2px)";
                      }}
                      title={isClickable ? `Click to mark as ${stage}` : isCompleted ? `Already ${stage}` : ""}
                    >
                      {stage}
                      {isClickable && (
                        <span style={{
                          position: "absolute",
                          top: "-8px",
                          right: "-8px",
                          // background: "#ff4081",
                          color: "white",
                          borderRadius: "50%",
                          width: "24px",
                          height: "24px",
                          fontSize: "14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "bold",
                          animation: "pulse 2s infinite",
                        }}>

                        </span>
                      )}
                    </div>
                    {index !== orderStages.length - 1 && <span style={styles.arrow}></span>}
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        );
      })}

    </div >
    ),

    Status:
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: '55vh',
        position: 'relative'
      }}>
        <div className="order-table-container">
          <style>
            {`
        .order-table-container {
          padding: 0px;
          font-family: Arial, sans-serif;
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        /* Fixed Header Section */
        .fixed-header {
          position: sticky;
          top: 0;
          
          background: white;
          padding: 2px 0;
          border-bottom: 0px solid #e0e0e0;
          margin-bottom: 00px;
        }

        .filters {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 15px;
          padding: 10px 0;
          width: 100%;
        }

        .filters button {
          padding: 8px 16px;
          background-color: #b15cd6;
          color: #fff;
          border: none;
          border-radius: 5px;
          font-weight: bold;
          cursor: pointer;
          white-space: nowrap;
          font-size: 14px;
          height: 40px;
        }

        /* Scrollable Table Area */
        .table-scroll-area {
          flex: 1;
          overflow-y: auto;
          overflow-x: auto;
          min-height: 300px;
          max-height: calc(100vh - 250px);
          border: 0px solid #e0e0e0;
          border-radius: 8px;
          margin-bottom: 0px;
          scrollbar-Width:none;
          -webkit-overflow-scrolling: touch;
          
        }

        /* Fixed Footer (Pagination) */
        .fixed-footer {
          position: sticky;
          bottom: 0;
          z-index: 100;
          background: white;
          padding: 5px 0;
          border-top: 0px solid #e0e0e0;
          margin-top: auto;
        }

        .pagination-controls {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 10px 0;
          background: #f8f9fa;
          border-radius: 8px;
          flex-wrap: wrap;
          gap: 10px;
          width: 100%;
        }

        .pagination-buttons {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
          justify-content: center;
        }

        .pagination-btn {
          padding: 8px 16px;
          background-color: #b15cd6;
          color: white;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-weight: bold;
          transition: background 0.3s;
          font-size: 14px;
        }

        .pagination-btn:hover:not(:disabled) {
          background-color: #9a4bc2;
        }

        .pagination-btn:disabled {
          background-color: #ccc;
          cursor: not-allowed;
          color:black;
        }

        /* Table Styles */
        table {
          width: 100%;
          border-collapse: collapse;
          min-width: 800px;
        }

        thead tr {
          background-color: #b15cd6;
          position: sticky;
          top: 0;
          z-index: 10;
        }

        th, td {
          padding: 8px 8px;
          border: 1px solid #e0e0e0;
          text-align: center;
          font-size: 14px;
          word-break: break-word;
          white-space:nowrap;
        }

        tbody tr:nth-child(even) {
          background-color: #f9f9f9;
        }

        tbody tr:nth-child(odd) {
          background-color: #ffffff;
        }

        tbody tr:hover {
          background-color: #f0e6f5;
        }

        /* Responsive Breakpoints */
        @media (max-width: 1400px) {
          table {
            min-width: 700px;
          }
          
          .table-scroll-area {
            max-height: calc(100vh - 240px);
          }
        }

        @media (max-width: 1200px) {
          table {
            min-width: 600px;
          }
          
          th, td {
            padding: 10px 12px;
            font-size: 13px;
          }
        }

        @media (max-width: 768px) {
          .filters {
            flex-direction: column;
            align-items: stretch;
            gap: 10px;
          }
          
          .filters > div {
            width: 100%;
            display: flex;
            justify-content: space-between;
          }
          
          table {
            min-width: 500px;
          }
          
          th, td {
            padding: 8px 10px;
            font-size: 12px;
          
          }
          
          .table-scroll-area {
            max-height: calc(100vh - 280px);
          }
        }

        @media (max-width: 576px) {
          table {
            min-width: 450px;
          }
          
          th, td {
            padding: 6px 8px;
            font-size: 11px;
          }
          
          .pagination-btn {
            min-width: 70px;
            padding: 6px 12px;
            font-size: 12px;
          }
        }
          .pagination-controls {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px 0;
      background: #f8f9fa;
      border-radius: 8px;
      width: 100%;
    }
    
    .pagination-buttons {
      display: flex;
      flex-wrap: nowrap; /* Prevent wrapping */
      gap: 8px;
      justify-content: center;
      align-items: center;
      width: 100%;
      max-width: 700px; /* Limit maximum width */
      overflow-x: auto; /* Allow horizontal scroll if needed */
      padding: 5px;
    }
    
    .pagination-btn {
      padding: 8px 12px;
      background-color: #b15cd6;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      font-weight: bold;
      font-size: 14px;
      white-space: nowrap;
      transition: background 0.3s;
      flex-shrink: 0; /* Prevent buttons from shrinking */
    }
    
    .pagination-btn:hover:not(:disabled) {
      background-color: #9a4bc2;
    }
    
    .pagination-btn:disabled {
      background-color: #ccc;
      cursor: not-allowed;
      opacity: 0.7;
    }
    
    /* Responsive adjustments */
    @media (max-width: 768px) {
      .pagination-buttons {
        gap: 5px;
        padding: 5px 2px;
      }
      
      .pagination-btn {
        padding: 6px 8px;
        font-size: 12px;
        min-width: auto; /* Remove min-width on mobile */
      }
      
      .pagination-btn:first-child,
      .pagination-btn:last-child {
        // display: none; /* Hide First/Last on very small screens if needed */
      }
    }
    
    @media (max-width: 576px) {
      .pagination-buttons {
        gap: 3px;
      }
      
      .pagination-btn {
        padding: 5px 6px;
        font-size: 11px;
      }
    }
    
    /* For very small screens, show only essential buttons */
    @media (max-width: 400px) {
      .pagination-buttons {
        justify-content: space-between;
        width: 100%;
      }
      
      .pagination-btn {
        flex: 1; /* Make buttons take equal space */
        padding: 6px 4px;
        font-size: 11px;
        text-align: center;
      }
    }
      @media (max-width:500px){
      .filters{
      padding:2px;
      }
      }
      ..fixed-footer{
      padding:0px;
      }
      `}
          </style>

          {/* FIXED HEADER: Date Filter & Export Button */}
          <div className="fixed-header" style={{zIndex:window.innerWidth<768 ?  "-1" : "100"}}>
            <div className="filters">
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                flexWrap: 'wrap',
                minHeight: '40px'
              }}>
                {/* Date Filter */}
                <button style={{ padding: "0", overflow: "hidden" }}>
                  <input
                    type="date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    style={{
                      background: "#b15cd6",
                      color: "#fff",
                      border: "none",
                      padding: "8px 12px",
                      height: "40px",
                      minWidth: "150px",
                      cursor: "pointer",
                      fontSize: "14px"
                    }}
                  />
                </button>

                {/* Export Button */}
                <button
                  onClick={() => exportAllOrdersForCSV()}
                  style={{
                    height:"40px",
                    padding:window.innerWidth<500 ? "0px 10px":"0px 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  Export
                </button>
              </div>
            </div>
          </div>

          {/* SCROLLABLE TABLE AREA */}
          <div className="table-scroll-area" style={{width:window.innerWidth<768 ? "94vw" : " "}}>
            {/* Show loader using your useLoader() hook */}
            {isLoadingStatus ? (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '200px',
                width: '100%'
              }}>
                {/* Your useLoader() should show a loader here automatically */}
                {/* Or you can trigger it like: */}
                {showLoader && <div>Loading...</div>}
              </div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th >S.No</th>
                    <th>Order ID</th>
                    <th>Date</th>
                    <th>Category</th>
                    <th>Type</th>
                    <th>Payment</th>
                    <th>Order Status</th>
                    <th>Amount</th>
                  </tr>
                </thead>

                <tbody>
                  {statusOrders.length === 0 ? (
                    <tr>
                      <td colSpan="8" style={{
                        textAlign: "center",
                        padding: "60px",
                        fontSize: "16px",
                        color: "#666"
                      }}>
                        {selectedDate ? `No orders found for ${selectedDate}` : "No orders found"}
                      </td>
                    </tr>
                  ) : (
                    statusOrders.map((item, index) => (
                      <tr key={index}>
                        <td>{(currentPage * 10) + index + 1}</td>
                        <td>{item.orderId}</td>
                        <td>{new Intl.DateTimeFormat("en-GB").format(new Date(item.orderDateAndTime))}</td>
                        <td>Food</td>
                        <td>{item.orderType}</td>
                        <td>
                          {item.paymentMethod === "OnlinePayment" ? "Online" :
                            item.paymentMethod === "MaamaasWallet" ? "Wallet" :
                              item.paymentMethod}
                        </td>
                        <td>{item.status}</td>
                        <td>₹{Math.round(item.grandTotal)}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            )}
          </div>



          {/* FIXED FOOTER: Pagination */}
          {statusOrders.length > 0 && !isLoadingStatus && totalPages > 1 && (
            <div className="fixed-footer">
              <div className="pagination-controls" style={{margin: window.innerWidth<768 ? "0px 30px" : " "}}>
                <div className="pagination-buttons">
                  {/* FIRST PAGE BUTTON */}
                  <button
                    disabled={currentPage === 0}
                    onClick={() => fetchPaginatedOrders(0)}
                    className="pagination-btn"
                    title="Go to first page"
                    
                  >
                      ⏮
                  </button>

                  {/* PREVIOUS BUTTON */}
                  <button
                    disabled={currentPage === 0}
                    onClick={goPrevious}
                    className="pagination-btn"
                    title="Previous page"
                    
                  >
                     ◀
                  </button>

                  {/* PAGE NUMBERS: P-1, P, P+1 */}
                  {getVisiblePages().map((p) => (
                    <button
                      key={p}
                      onClick={() => fetchPaginatedOrders(p)}
                      className="pagination-btn"
                      style={{
                        backgroundColor: currentPage === p ? "#31173eff" : "#b15cd6",
                        fontWeight: currentPage === p ? "bold" : "normal",
                        minWidth: "25px"
                      }}
                    >
                      {p + 1}
                    </button>
                  ))}

                  {/* NEXT BUTTON */}
                  <button
                    onClick={goNext}
                    disabled={currentPage >= totalPages - 1}
                    className="pagination-btn"
                    title="Next page"
                    
                  >
                     ▶
                  </button>

                  {/* LAST PAGE BUTTON */}
                  <button
                    disabled={currentPage >= totalPages - 1}
                    onClick={() => fetchPaginatedOrders(totalPages - 1)}
                    className="pagination-btn"
                    title="Go to last page"
                    
                  >
                     ⏭
                  </button>
                </div>

                
              </div>
            </div>
          )}
        </div>
      </div>


  };

  return (

    <div>

      <style>{`
        .main-container {
          padding: 20px;
          display: flex;
          flex-direction: column;

        }
@media screen and (min-width: 768px) {
         .tabs-wrapperyyy {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
          margin-top:-46px;
}
      }


/* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
@media screen and (max-width: 768px) {
  .tabs-wrapper {
    margin-left: 0;

  }
       .tabs-wrapperyyy {
      display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
          margin-top:-30px;
}
            .tab-content {
          width: 100%;
          max-width:944px;


        }
}


        .tab-buttons {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin-top:30px;

        }

        .tab-button {
          border: none;
          border-radius: 10px;
          width: auto;
          height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .tab-button.active {
          background-color: #b15cd6;
        }



        .sidebar {
          margin-top: 30px;
          max-height: 600px;
          overflow-y: auto;
        }

        .card {
          width: 100%;
          max-width: 300px;
          height: 120px;
          background: #ccc;
          border-radius: 8px;
          box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
          margin: 10px auto;
          position: relative;
          padding: 10px;
        }

        .card h5, .card p {
          color: white;
          margin: -18 !imortanant;
        }




        @media (min-width: 768px) {
          .main-container {
            flex-direction: row;
            justify-content: space-between;
          }
  .tab-content {
          margin-top: 0px;
          width: 100%;
          max-width:944px;

        }

         .left-column {
    padding-right: 0;
    display: flex;
    flex-direction: column;         /* stack children vertically */

    justify-content: center;        /* center vertically */
    text-align: center;
    margin: 0 auto;
  }

          .right-column {
            width: 30%;
            position: sticky;
            top: -30px;
            max-height: 700px;
            overflow-y: auto;
          }

          .card {
            margin-left: 0;
          }
            .tabs-wrapperyyy{
            margin-left:none

            }

        }

        /* Hide native scrollbars */
        .sidebar::-webkit-scrollbar,
        .left-column::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }


/* Media queries for different screen heights */
@media (max-height: 400px) {
  .tab-content {
    height: 50vh !important;
  }
}

@media (min-height: 401px) and (max-height: 500px) {
  .tab-content {
    height: 50vh !important;
  }
}

@media (min-height: 501px) and (max-height: 600px) {
  .tab-content {
    height: 50vh !important;
  }
}

/* For screens taller than 600px */
@media (min-height: 601px)and (max-height: 700px) {
  .tab-content {
    height: 55vh !important; /* Or use your containerHeight value */
  }
}
  @media (min-height : 701px){
  .tab-content {
    height: 60vh !important; /* Or use your containerHeight value */
  }
  }
      `}</style>

      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-lg-2 col-md-12 col-sm-12 col-12"></div> */}
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">


            {/* Left Section */}
            <div className="left-column" style={{}}>
              <div className="tabs-wrapperyyy ">

                <div className="tab-buttons" style={{}}>
                  {Object.keys(tabContent).map((label) => (
                    <button
                      key={label}
                      className={`tab-button ${activeTab === label ? "active" : ""}`}
                      onClick={() => setActiveTab(label)}
                    >
                      {label}
                    </button>
                  ))}
                </div>
                <div className="tab-content" style={{
                  // overflow: 'auto',
                  // scrollbarWidth: "thin",
                  msOverflowStyle: "none", maxWidth: '944px',
                }}>{tabContent[activeTab]}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  );
};

export default Standardorder;

